import { PropsWithChildren } from 'react';
import { Provider } from 'react-redux';
import store from 'store';

export const StoreProvider = (props: PropsWithChildren<Record<string, unknown>>) => {
    return <Provider store={store}>{props.children}</Provider>;
};
